(function($) {
    $(function () {
        var body = $('body');

        if(body.hasClass('page-template-user-edit')) {
            var savePublicationBtn = $('#savePublicationBtn');
            var addPublicationFields = $('#addPublicationFields');
            var accountUserForm = $('#accountUser');

            savePublicationBtn.on('click', function(ev) {
                ev.preventDefault();
                var action = $('#action');
                action.val('edit-publication');

                accountUserForm.submit();
            });

            body.on('click', '.modal-comments .saveCommentBtn', function(ev) {
                ev.preventDefault();
                var saveBtn = $(ev.target);

                if(saveBtn.hasClass('disable')) {
                    return false;
                }

                var modal = saveBtn.parents('.modal-comments');
                var commentInput = modal.find('.comment-input');
                var commentsView = modal.find('.existing-comments-view');

                var errorValidation = modal.find('.description.error');
                errorValidation.addClass('d-none');

                var commentInputText = commentInput.val().trim();

                if(!commentInputText) {
                    errorValidation.toggleClass('d-none');
                    return;
                }

                saveBtn.addClass('disable');

                $.ajax({
                    url: drturner_params.ajax_url,
                    type: 'post',
                    data: {
                        action: 'save_publication_comment',
                        comment: commentInputText,
                        postId: modal.data('pub-id')
                    },
                    success: function(resp) {
                        let {data} = resp;

                        commentsView.html(data);
                        commentsView[0].scrollTop = commentsView[0].scrollHeight;
                        commentInput.val('');


                    },
                    complete: function() {
                        saveBtn.removeClass('disable');
                    }
                });
            });
        }
    });
})(jQuery);
